import * as React from "react";

function SvgVisaCard(_ref, svgRef) {
  let { title, titleId, ...props } = _ref;
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: 50,
      height: 17,
      viewBox: "0 0 50 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef,
      "aria-labelledby": titleId,
      ...props,
    },
    title ? /*#__PURE__*/ React.createElement("title", { id: titleId }, title) : null,
    /*#__PURE__*/ React.createElement("g", { clipPath: "url(#clip0_1078_27)" },
      /*#__PURE__*/ React.createElement("path", {
        d: "M32.6578 0.174316C28.681 0.174316 ...",
        fill: "#0023A0",
      }),
      /*#__PURE__*/ React.createElement("path", {
        d: "M6.70177 0.452794H0.218083 ...",
        fill: "#FFAB00",
      })
    ),
    /*#__PURE__*/ React.createElement("defs", null,
      /*#__PURE__*/ React.createElement("clipPath", { id: "clip0_1078_27" },
        /*#__PURE__*/ React.createElement("rect", { width: 50, height: 16.4252, fill: "white" })
      )
    )
  );
}

const ForwardRef = /*#__PURE__*/ React.forwardRef(SvgVisaCard);
export default ForwardRef;
export { ForwardRef as ReactComponent };